import styled from 'styled-components';

export const AkitsuStyled = styled.div``;
